import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateMeal } from '../../../api/diary-service';
import refetchDiaryAndEnergy from '../../../services/refetch-queries';

const useUpdateMeal = (currentDay) => {
    const [isUpdating, setIsUpdating] = useState(false);
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: ({ mealId, mealData }) => updateMeal(mealId, mealData),
        onError: (error) => console.error('Failed to update meal:', error)
    });

    const updateMealAndSync = async (mealId, mealData) => {
        setIsUpdating(true);

        try {
            await mutation.mutateAsync({ mealId, mealData });
            await refetchDiaryAndEnergy(queryClient, currentDay);
        } catch (error) {
            console.error('Update and sync failed:', error);
        } finally {
            setIsUpdating(false);
        }
    };

    return {
        updateMeal: updateMealAndSync,
        isUpdating: isUpdating,
        isSuccess: mutation.isSuccess,
        isError: mutation.isError,
        error: mutation.error
    };
};

export default useUpdateMeal;
